import { stBrandBlue, stBrandPink } from '$lib/shared/lib/colors';
import type { SpeakerImage, StreamSettings } from '$lib/shared/lib/types';
// TODO: Rename this file or move this particle stuff somewhere else

export function createParticles(
	colors: string[] | null = null,
	shapes: string[] | null = null
):
	| import('@tsparticles/engine').RecursivePartial<import('@tsparticles/engine').IOptions>
	| undefined {
	const particlesConfig:
		| import('@tsparticles/engine').RecursivePartial<import('@tsparticles/engine').IOptions>
		| undefined = {
		fullScreen: {
			enable: false
		},
		fpsLimit: 60,
		detectRetina: true,
		emitters: {
			position: {
				x: 50,
				y: 0
			},
			direction: 'top',
			size: {
				width: 100,
				height: 0
			},
			rate: {
				quantity: 3,
				delay: 0.15
			}
		},
		particles: {
			color: {
				value: colors ?? [stBrandBlue, stBrandPink]
				//value: ['#1565C0', '#00E5FF', '#0F9D58', '#FFCA28', '#F57C00', '#E91E63', '#E62117']
			},
			move: {
				decay: 0.05,
				direction: 'top',
				enable: true,
				gravity: {
					enable: true
				},
				outModes: {
					top: 'none',
					default: 'destroy'
				}
			},
			number: {
				value: 0
			},
			opacity: {
				value: 1
			},
			rotate: {
				value: {
					min: 0,
					max: 360
				},
				direction: 'random',
				animation: {
					enable: true,
					speed: 20
				}
			},
			tilt: {
				direction: 'random',
				enable: true,
				value: {
					min: 0,
					max: 360
				},
				animation: {
					enable: true,
					speed: 20
				}
			},
			size: {
				value: 3,
				animation: {
					enable: true,
					startValue: 'min',
					count: 1,
					speed: 16,
					sync: true
				}
			},
			roll: {
				darken: {
					enable: true,
					value: 25
				},
				enlighten: {
					enable: true,
					value: 25
				},
				enable: true,
				speed: {
					min: 5,
					max: 15
				}
			},
			wobble: {
				distance: 20,
				enable: true,
				speed: {
					min: -7,
					max: 7
				}
			},
			shape: {
				type: shapes ?? ['circle', 'square'],
				options: {}
			}
		},
		responsive: [
			{
				options: {
					particles: {
						move: {
							speed: {
								min: 0,
								max: 0
							}
						}
					}
				}
			}
		]
	};
	return particlesConfig;
}
export function createDrawer() {
	const image_size = 180.0;
	const rms_scale = 0.5;
	const rotation_limit = Math.PI / 15.0;
	const canvas_size = image_size + rms_scale * image_size;

	let headGrowing = false;
	let previousRms = 0.0;
	let rotation = 0.0;

	let canvas: HTMLCanvasElement | null = null;
	let ctx: CanvasRenderingContext2D | null = null;

	function getCanvasContext(): CanvasRenderingContext2D | null {
		if (ctx !== null) return ctx;

		canvas = document.getElementById('canvas') as HTMLCanvasElement | null;
		if (canvas === null) return null;

		ctx = canvas.getContext('2d');
		return ctx;
	}

	return { draw, canvas_size };

	function draw(
		speakerImage: SpeakerImage,
		settings: StreamSettings,
		dataArrayCopy: number[]
	): void {
		const context = getCanvasContext();
		if (context === null || canvas === null) return;

		context.clearRect(0, 0, canvas_size, canvas_size);

		let sumSquares = 0;
		for (let i = 0; i < dataArrayCopy.length; i++) {
			sumSquares += dataArrayCopy[i] * dataArrayCopy[i];
		}
		const mean = sumSquares / dataArrayCopy.length;
		let rms = Math.sqrt(mean) * rms_scale;

		if (Math.abs(rms - previousRms) > 0.01 * rms_scale) {
			if (rms > previousRms) {
				if (!headGrowing) {
					rotation = Math.random() * rotation_limit - rotation_limit / 2.0;
				}
				headGrowing = true;
			} else {
				headGrowing = false;
			}
			previousRms = rms;
		}

		if (settings.voice_disable_animate_speaker_head) {
			rotation = 0.0;
			rms = 0.0;
		}

		if (settings.voice_hide_speaker_head) {
			return;
		}

		const axis = image_size * (rms + 1.0) * 0.5;
		const canvas_center = canvas_size * 0.5;
		const size = image_size * (rms + 1.0);

		if (speakerImage?.image) {
			context.save();
			context.translate(canvas_center, canvas_center);
			context.rotate(rotation);
			context.drawImage(speakerImage.image, -axis, -axis, size, size);
			context.restore();
		}
	}
}
